export function searchFilter(item: [], search: string): boolean {
    let normalizedSearch = search
        .normalize("NFD")
        .replace(/[^\w\s]/gi, '')
        .replace(/  +/g, ' ')
        .toLowerCase()
        .trim();

    return Object.keys(item).some(function (key: string) {
        // When a value is null, we cannot perform a search
        if (item[key as keyof []] === null) return false
        // Removing all non alphanumeric characters and normalize the string
        return item[key as keyof []].toString()
            .toLowerCase()
            .normalize("NFD")
            .replace(/[^\w\s]/gi, '')
            .replace(/  +/g, ' ')
            .trim()
            .includes(normalizedSearch)
    });
}